import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import SvgIcon from '@/icons'
import '@/router/permission.js'
import 'element-plus/dist/index.css'
import '@/assets/styles/border.css'
import '@/assets/styles/reset.css'
import '@/assets/styles/global.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

//createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
// 国际化中文
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const app=createApp(App)
SvgIcon(app);

app.use(store)

app.use(router)

// app.use(ElementPlus)

app.use(ElementPlus, {
    locale: zhCn,
})

// 注册所有图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')